import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { SchoolRounded } from "@mui/icons-material";
import PageHeader from "../components/page-header";
import { Dialogs } from "../components/dialogs";
import StickyHeadTable, { Column } from "../components/table";
import { School } from "../types/exames";
import { ViewModelSchool } from "../viewmodel/viewmodel-school";

function SchoolsPage() {
  const {
    dialog,
    handleDeleteSchool,
    showWarning,
    handleActionSchool,
    showConfirmation,
    ...viewModel
  } = ViewModelSchool();

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleOpen = () => {
    setEditMode(false);
    setName("");
    setDescription("");
    setOpen(true);
  };

  const handleEdit = (id: number) => {
    const school = viewModel.schools.data.find((t) => t.id === id);
    if (school) {
      setEditMode(true);
      setName(school.name);
      setDescription(school.description || "");
      viewModel.selectSchool(school);
      setOpen(true);
    }
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      showWarning({
        title: "Erro",
        message: "O nome da secção é obrigatório"
      });
      return;
    }
    setOpen(false);
    editMode && viewModel.selectedSchool?.id
      ? handleActionSchool({
        id: viewModel.selectedSchool.id, name, description
      }, 'update')
      : handleActionSchool({
        name, description
      } as School, 'add');
  };

  const handleDelete = (id: number) => {
    const school = viewModel.schools.data.find((t) => t.id === id);
    showConfirmation({
      title: "Confirmar Eliminação",
      message: `Tem a certeza que deseja eliminar a secção "${school?.name}"? Esta ação não pode ser desfeita.`,
      onConfirm: () => handleDeleteSchool(id),
    });
  };

  const columns: Column<School>[] = [
    { id: "id", label: "ID", minWidth: 100 },
    { id: "name", label: "Nome", minWidth: 300 },
    {
      id: "description",
      label: "Descrição",
      minWidth: 400,
      renderCell: (row) => row.description || "Sem descrição"
    },
    {
      id: "actions",
      label: "Ações",
      minWidth: 190,
      renderCell: (row) => (
        <Box>
          <Tooltip title="Editar" arrow>
            <IconButton
              size="small"
              onClick={() => handleEdit(row.id!)}
              color="primary"
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Eliminar" arrow>
            <IconButton
              size="small"
              color="error"
              onClick={() => handleDelete(row.id!)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Ver Exames" arrow>
            <Button
              size="small"
              color="success"
              onClick={() => viewModel.goToExames(row.id!)}
            >
              Exames
            </Button>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <PageHeader
        icon={<SchoolRounded />}
        color="#F59E0B"
        title="Gestão de Secções"
        actions={
          <Button variant="contained" onClick={handleOpen}>
            Nova Secção
          </Button>
        }
      />

      <StickyHeadTable
        columns={columns}
        rows={viewModel.schools.data}
        getRowId={(row) => row.id!}
        pagination={{
          totalData: viewModel.schools.pagination.totalData,
          totalPages: viewModel.schools.pagination.totalPages,
          currentPage: viewModel.schools.pagination.currentPage,
          onPageChange: (newPage) => {
            viewModel.fetchSchools(newPage);
          },
          onRowsPerPageChange: () => { },
        }}
      />

      {/* Create/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editMode ? "Editar Secção" : "Nova Secção"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome da Secção"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Descrição"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained">
            {editMode ? "Actualizar" : "Criar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialogs{...dialog} />
    </Container>
  );
}

export default SchoolsPage;
